import { scrollAnime } from "./components/scrollAnime";
import { humbergerMenuButton } from "./components/humbergerMenuButton";
import { accordion } from "./components/accordion";
import { tab } from "./components/tab";
import { inputError } from "./components/inputError";
import { megaMenu } from "./components/megaMenu";
import { pageTop } from "./components/pageTop";
import Splide from '@splidejs/splide';
import '@splidejs/splide/css/core';



$(document).ready(function () {

  (() => {
    /*
    アニメーション用関数
    */
    //アニメーション用クラスを定義
    const animeEl = ".u-anime";
    //スクロール時に付与されるクラス定義
    const addAnimeClass = "fadeIn";
    scrollAnime(animeEl, addAnimeClass);

  })();

  (() => {
    /*
    ハンバーガーメニュー用関数
    */
    //ハンバーガーメニューボタンクラス定義
    const buttonEl = "#humberge-button";
    //ハンバーガーメニュークラス定義
    const menuEl = "#humberge-menu";
    humbergerMenuButton(buttonEl, menuEl);
  })();

  // (() => {
  //   /*
  //   スライダー用関数
  //   */
  //   const sliderEl = ".swiper";
  //   slider(sliderEl);
  // })();

  (() => {
    /*
    アコーディオン用関数
    */
    //アコーディオンラッパークラス定義
    const accordionEl = ".accordion";
    //アコーディオンボタンクラス定義
    const accordionButtonEl = ".accordionButton";
    //アコーディオンアイテムクラス定義
    const accordionItemEl = ".accordionItem";
    accordion(accordionEl, accordionButtonEl, accordionItemEl);
  })();

  (() => {
    /*
    タブ用関数
    */
    //タブボタンラッパークラス定義
    const tabButtonEl = ".tabButton";
    //タブコンテンツラッパークラス定義
    const tabContentsEl = ".tabContent";
    tab(tabButtonEl, tabContentsEl);
  })();

  (() => {
    /*
    メガメニュー用関数
    */
    //メガメニューラッパークラス定義
    const megaMenuEl = "#megaMenu";
    //メガメニューナビアイテムクラス定義
    const megaMenuItemEl = ".megaMenuItem";
    //メガメニューコンテンツクラス定義
    const megaMenuContents = ".megaMenuContents";
    megaMenu(megaMenuEl, megaMenuItemEl, megaMenuContents);
  })();

  (() => {
    /*
    フォームバリデーション用関数
    */
    //フォームラッパークラス定義
    const formEl = ".p-form";
    //エラー表示用クラス定義
    const addErrorClass = "c-error";
    //WPなどでフォームから出力されるエラークラスを定義
    const errorEl = "error";
    inputError(formEl, addErrorClass, errorEl);
  })();

  (() => {
    /*
    ページトップボタン用関数
    */
    //ボタンクラス定義
    const pageTopButtonEl = "#pageTop";
    //初期状態を定義
    const hide = true;
    pageTop(pageTopButtonEl, hide);
  })();

// TOPページスライダー

let splideCheck = document.getElementsByClassName("splide").length;
  if(splideCheck) {
    let splide = new Splide( '.splide', {
      type    : 'loop',
      autoplay: 'true',
      perPage: 3,
      perMove: 1,
      focus  : 0,
      padding: '1rem',
      keyboard: true,
      breakpoints: {
        767: { // 767px以下の場合の挙動
          perPage: 1,
          padding: '2rem',
        }
      }
    });
    splide.mount();
  }

});

$(window).on("scroll", function () {
  let registerbtn = $("#registerbtn");
  let scrollHeight = $(document).height();
  let scrollPosition = $(window).height() + $(window).scrollTop();
  let footHeight = $("footer").innerHeight() - 80;
  let footpos = $("footer").innerHeight() + 100;
  if (scrollHeight - scrollPosition <= footHeight) {
    // ページトップボタンがフッター手前に来たらpositionとfixedからabsoluteに変更
    registerbtn.css({
      position: "absolute",
      bottom: footpos,
    });
  } else {
    registerbtn.css({
      position: "fixed",
      bottom: "150px",
    });
  }
});

$(function () {
  $('a[href^="#"]').on("click", function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    var speed = 500;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });
});

  //データベース検索の全角スペースを半角スペースに変換する
  $(function () {
    $("#dbfreeword").on("blur" , function() {
        var text = $('#dbfreeword').val();
        var replacedText = text.replace(/\u3000/g, ' ');
        $('#dbfreeword').val(replacedText);
    });
  });

    //会員検索の全角スペースを半角スペースに変換する
    $(function () {
      $("#company").on("blur" , function() {
          var text = $('#company').val();
          var replacedText = text.replace(/\u3000/g, ' ');
          $('#company').val(replacedText);
      });
    });

    //会員登録にhtml挿入及びフォームアイテムにクラス付与
    $(function () {
      $("#user_company").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#user_position").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#representative_name").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#representative_kana").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#billing_postcode").addClass('c-form__input--squregraymembers p-form__item__input--exmin');
      $("#billing_address_1").addClass('c-form__input--squregraymembers');
      $("#last_name").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#first_name").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#last_name_kana").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#first_name_kana").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#department_name").addClass('c-form__input--squregraymembers p-form__item__input--middle');
      $("#billing_phone").addClass('c-form__input--squregraymembers p-form__item__input--min');
      $("#password").addClass('c-form__input--squregraymembers p-form__item__input--min');
      $("#business_content").addClass('c-form__input--squregraymembers');
      $("#comment").addClass('c-form__input--squregraymembers');
      $("#business_content").before('<p class="p-form__item__text">他の会員にアピールする内容をご記入ください。</p><p class="p-form__item__example u-mb--10">例) 宿泊施設の経営</p>');
      $("#Industry_other_detail").before('<p class="p-form__item__text u-mb--10">業種でその他を選んだ場合のみ入力してください。</p>');
      $("#comment").before('<p class="p-form__item__text u-mb--10">ICOIプロジェクトに期待することや、温泉を活用したヘルスケア産業への思いなどをご記入ください。</p>');
      $("#comment").addClass('c-form__input--squregraymembers');
      $("#user_email").addClass('c-form__input--squregraymembers');
      $("#user_email").before('<p class="p-form__item__text u-mb--10">ご記入いただいたメールアドレスが「ログインID」となります。</p>');
      $("#confirm_email").addClass('c-form__input--squregraymembers');
      $("#password").before('<p class="p-form__item__text u-mb--10">※半角英数字8文字以上でご入力ください。</p>');
      $("#user_public_option_1").before('<p class="p-form__item__text">会員検索ページにて、会社名・団体名等/所在地/業種/主な事業内容/一言コメントを「公開する」と選択いただくと公開されます。</p><p class="p-form__item__text">「公開しない」をご選択の場合は、検索結果に掲載されません。</p><p class="p-form__item__text u-mb--10">公開設定は会員マイページから変更することができます。</p>');
      $("#user_mailmagazine_1").before('<p class="p-form__item__text">メールマガジンの配信を希望される場合は「希望する」を選択ください。</p><p class="p-form__item__text">イベントの開催や補助金の募集案内等、重要なお知らせをメルマガで御連絡させていただきますので、差し支えなければ「希望する」を選択いただけますと幸いです。</p><p class="p-form__item__text u-mb--10">メールマガジンの配信設定は会員マイページから変更することができます。</p>');
    });
    
    //ログイン画面にhtml挿入及びフォームアイテムにクラス付与
    $(function () {
      $("#log").addClass('c-form__input--circlesqureyellowmembers p-login__input');
      $("#pwd").addClass('c-form__input--circlesqureyellowmembers p-login__input');
      $("#register-main").find('.button_div').before('<div class="p-form__check"><input type="checkbox" id="terms02" name="terms02" class="buttoncheck"><label class="c-text--base" for="terms02">上記内容に間違いがないことを確認した</label></div>');
      $("#register-main").find('.button_div').addClass('c-button__normal p-button--red p-register__submit c-button__link__arrow p-button--disabled');
      $("#register-main").find('.button_div').children('input').addClass('c-button__link--red u-border--none');
      $("#p-login__formblock").find(".link-text-register").parent().addClass('u-display--none');
      $("#p-login__formblock").find('.button_div').addClass('c-button__normal p-button--red p-login__submit c-button__link__arrow');
      $("#p-login__formblock").find('.button_div').children('input').addClass('c-button__link--red u-border--none');
    });

    //マイページ画面にhtml挿入及びフォームアイテムにクラス付与
    $(function () {
      $("#mypage").find('.button_div').addClass('c-button__normal p-button--red p-mypage__submit c-button__link__arrow');
      $("#mypage").find('.button_div').children('input').addClass('c-button__link--red u-border--none');
    });

      //パスワードリセット画面にhtml挿入及びフォームアイテムにクラス付与
      $(function () {
        $("#user").addClass('c-form__input--squregraymembers p-login__input');
        $("#passreset").find('.button_div').addClass('c-button__normal c-button__arrowbgblack p-reset__btn');
        $("#passreset").find('.button_div').children('input').addClass('c-button__link--black u-border--none');
        $("#wpmem_pwdchange_form").find('.button_div').children('input').attr('id', 'hoge');
        $("#wpmem_pwdchange_form").find('.button_div').children('input').addClass('p-button--disabled');
      });

      // p-button--disabled
    $(function () {
      $('.buttoncheck').on("change" , function() {
        // チェックボックスの状態を取得
        const allChecked = $('.buttoncheck:checked').length === 3;

        if (allChecked) {
            $("#register-main").find('.button_div').removeClass('p-button--disabled');
        } else {
            $("#register-main").find('.button_div').addClass('p-button--disabled');
        }
      });
    });

    //パスワード変更の際の一致するかのバリデーション
    $(function () {
      // $('#p-login__formblock').prev('.err').text( '' ).css( 'display', 'none' ); 
      $('#pass1,#pass2').on("change" , function() {
        let pass01 = $('#pass1').val();
        let pass02 = $('#pass2').val();
        if(pass01.length && pass02.length) {
          if(pass01 == pass02) {
            if($('#hoge').hasClass('p-button--disabled')) {
              $('#hoge').removeClass("p-button--disabled");
            }
            // $('#p-login__formblock').prev('.err').text( '' ).css( 'display', 'none' ); 
          } else {
            if(!$('#hoge').hasClass('p-button--disabled')) {
              $('#hoge').addClass("p-button--disabled");
            }
            // $('#p-login__formblock').prev('.err').text( 'エラー：パスワードが一致していません。' ).css( 'display', 'block' ); 
          }
        }
      });
    });

    //余分な空白を削除
    $(function () {
        $("#p-login__formblock").find('.button_div').html(function(_, html) {
            return html.replace(/&nbsp;/g, '');
        });
    });

    var options=[]; 
$( "#categorychecklist label" ).each(function(){ 
    options.push( '<option value="' + $(this).children("input").val()+ '">' + $(this).html().replace(/<input[^>]+>/g, '') + '</option>' ); 
});
$( "#categorychecklist" ).replaceWith( '<select id="categorychecklist" name="tax_input[category][]" style="width:100%; margin:10px 0; ">' + options.join( '' ) + '</select>' );

